import { LoadingFSProps } from "../../hooks";

export enum WebEnum {
  LOADING = "web/loading",
  OPERATIONS_PER_DAY = "web/operationPerDay",
  ARRAY_RANDOM_20_DARK_COLORS = "web/arrayRandom20DarkColors",
}

export interface WebProps {
  loading: LoadingFSProps;
  operationsPerDay: number;
  arrayRandom20DarkColors: string[];
}

export interface WebDispatchProps extends WebProps {
  dispatch: React.Dispatch<any>;
}
